import { render, staticRenderFns } from "./Boardhouse.vue?vue&type=template&id=6fcae80d&scoped=true"
import script from "./Boardhouse.vue?vue&type=script&lang=js"
export * from "./Boardhouse.vue?vue&type=script&lang=js"
import style0 from "./Boardhouse.vue?vue&type=style&index=0&id=6fcae80d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcae80d",
  null
  
)

export default component.exports